var App = App || {};

App.Forms = (function ($) {
    "use strict";

    var umbracoForms = $(".umbraco-forms-page");

    function init() {
        umbracoForms.each(function () {
            var parentForm = $(this);
            var submitBtn = parentForm.find('input[type="submit"]');

            submitBtn.click(function () {
                var invalidFields = parentForm.find(".input-validation-error");
                if (invalidFields.length) {
                    invalidFields.first().focus();
                }
            });
        });
    }

    return {
        init: init
    };

})(jQuery);

$(function () {
    App.Forms.init();
});